/* eslint-disable no-console */
import type { PaymentIQGeneralSettings } from 'apps/core/types/web-storage.types';
import { WebStorageKeys } from 'apps/core/types/web-storage.types';

export const setPaymentIqGeneralSettings = (newValue: PaymentIQGeneralSettings): void => {
  const currentSettings: PaymentIQGeneralSettings | undefined = getWebStorage(
    WebStorageKeys.PAYMENTIQ_GENERAL_SETTINGS,
  );
  setWebStorage(WebStorageKeys.PAYMENTIQ_GENERAL_SETTINGS, {
    ...(currentSettings || {}),
    ...newValue,
  });
};

export const getWebStorage = <T>(key: WebStorageKeys): T | undefined => {
  const data: string | null = sessionStorage.getItem(key) || localStorage.getItem(key);
  try {
    return data ? (JSON.parse(data) as T) : undefined;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

export const setWebStorage = <T>(
  key: WebStorageKeys,
  value: T | string | number | Record<string, unknown>,
): void => {
  const data: string = typeof value === 'string' ? value : JSON.stringify(value);
  sessionStorage.setItem(key, data);
  localStorage.setItem(key, data);
};
